export const LINE_COLORS = [
  '#5BAC4D',
  '#FF2710',
  '#7DE2D3',
  '#0CB2B2',
  '#146A59',
  '#91D400',
  '#B581A2',
  '#34158C',
  '#A40965',
  '#F7DB71',
  '#13682B',
  '#7D69B5',
]
